import { MasterLayout } from '@/_metronic/layout/MasterLayout';
import { ANNOUNCEMENTS_PAGE_URL, MANAGER_DASHBOARD_PAGE_URL } from '@/api/core/links';
import { Navigate, Route, Routes } from 'react-router-dom';
import SuspensedView from '@/app/components/layout/SuspensedView';
import ManagerSpaceDashboardPage from '@/app/pages/manager-space/ManagerSpaceDashboardPage';
import AnnouncementWrapper from '@/app/pages/notifications/announcements/AnnouncementWrapper';

const ManagerRoutes = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route index element={<Navigate to={MANAGER_DASHBOARD_PAGE_URL} />} />
        <Route
          element={
            <SuspensedView>
              <ManagerSpaceDashboardPage />
            </SuspensedView>
          }
          path={MANAGER_DASHBOARD_PAGE_URL}
        />
        <Route
          element={
            <SuspensedView>
              <AnnouncementWrapper />
            </SuspensedView>
          }
          path={`${ANNOUNCEMENTS_PAGE_URL}/*`}
        />
        <Route element={<Navigate to="/error/404" />} path="*" />
      </Route>
    </Routes>
  );
};

export { ManagerRoutes };
